import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#161B26] text-white py-16 border-t border-[rgba(255,255,255,0.1)]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 group mb-4">
              <div className="w-10 h-10 bg-transparent rounded-lg flex items-center justify-center overflow-hidden">
                <img 
                  src={`${process.env.PUBLIC_URL}/man-and-machine-logo.png`}
                  alt="Man & Machine Logo" 
                  className="w-10 h-10 object-cover"
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              </div>
              <div className="flex flex-col">
                <span className="text-lg font-bold tracking-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                  <span className="text-white">MAN</span>
                  <span className="text-[#00E5C0] mx-1">&</span>
                  <span className="text-white">MACHINE</span>
                </span>
              </div>
            </Link>
            <p className="text-white font-semibold mb-1">
              Service Business Agentic AI OS.
            </p>
            <p className="text-[#718096] text-sm">
              Analyse, plan, and deploy AI across your business.
            </p>
          </div>

          {/* Column 1 — Platform (SEO Sitelinks) */}
          <div>
            <h4 className="font-semibold mb-4 text-sm text-white uppercase tracking-wider">Platform</h4>
            <nav aria-label="Platform links">
              <ul className="space-y-3">
                <li>
                  <Link to="/ai-agents" className="text-[#718096] hover:text-[#00E5C0] transition-colors text-sm">
                    Workers
                  </Link>
                </li>
                <li>
                  <Link to="/mcp" className="text-[#718096] hover:text-[#00E5C0] transition-colors text-sm">
                    Integrations
                  </Link>
                </li>
                <li>
                  <Link to="/command" className="text-[#718096] hover:text-[#00E5C0] transition-colors text-sm">
                    Command
                  </Link>
                </li>
                <li>
                  <Link to="/create-agent" className="text-[#718096] hover:text-[#00E5C0] transition-colors text-sm">
                    Create a Worker
                  </Link>
                </li>
                <li>
                  <Link to="/features" className="text-[#718096] hover:text-[#00E5C0] transition-colors text-sm">
                    Features
                  </Link>
                </li>
                <li>
                  <Link to="/pricing" className="text-[#718096] hover:text-[#00E5C0] transition-colors text-sm">
                    Pricing
                  </Link>
                </li>
              </ul>
            </nav>
          </div>

          {/* Column 2 — Partners */}
          <div>
            <h4 className="font-semibold mb-4 text-sm text-white uppercase tracking-wider">Partners</h4>
            <nav aria-label="Partner links">
              <ul className="space-y-3">
                <li>
                  <Link to="/partners" className="text-[#718096] hover:text-[#00E5C0] transition-colors text-sm">
                    Find a Partner
                  </Link>
                </li>
                <li>
                  <Link to="/partners/apply" className="text-[#718096] hover:text-[#00E5C0] transition-colors text-sm">
                    Become a Partner
                  </Link>
                </li>
              </ul>
            </nav>
          </div>

          {/* Column 3 — Resources */}
          <div>
            <h4 className="font-semibold mb-4 text-sm text-white uppercase tracking-wider">Learn</h4>
            <nav aria-label="Learn links">
              <ul className="space-y-3">
                <li>
                  <Link to="/resources" className="text-[#718096] hover:text-[#00E5C0] transition-colors text-sm">
                    Blog
                  </Link>
                </li>
                <li>
                  <Link to="/resources" className="text-[#718096] hover:text-[#00E5C0] transition-colors text-sm">
                    eBook
                  </Link>
                </li>
                <li>
                  <Link to="/how-we-score" className="text-[#718096] hover:text-[#00E5C0] transition-colors text-sm">
                    How We Score
                  </Link>
                </li>
                <li>
                  <Link to="/help" className="text-[#718096] hover:text-[#00E5C0] transition-colors text-sm">
                    Help Centre
                  </Link>
                </li>
                <li>
                  <Link to="/security" className="text-[#718096] hover:text-[#00E5C0] transition-colors text-sm">
                    Security
                  </Link>
                </li>
              </ul>
            </nav>
          </div>

          {/* Column 4 — Company */}
          <div>
            <h4 className="font-semibold mb-4 text-sm text-white uppercase tracking-wider">Company</h4>
            <nav aria-label="Company links">
              <ul className="space-y-3">
                <li>
                  <Link to="/about" className="text-[#718096] hover:text-[#00E5C0] transition-colors text-sm">
                    About
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-[#718096] hover:text-[#00E5C0] transition-colors text-sm">
                    Contact
                  </Link>
                </li>
                <li>
                  <Link to="/privacy" className="text-[#718096] hover:text-[#00E5C0] transition-colors text-sm">
                    Privacy
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="text-[#718096] hover:text-[#00E5C0] transition-colors text-sm">
                    Terms
                  </Link>
                </li>
                <li>
                  <Link to="/affiliate-terms" className="text-[#718096] hover:text-[#00E5C0] transition-colors text-sm">
                    Affiliate Terms
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        {/* Legal Footer Bar */}
        <div className="border-t border-[rgba(255,255,255,0.1)] pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-[#718096] text-sm">
              © 2026 Global Doorstep Pty Ltd
            </p>
            <nav aria-label="Legal links" className="flex flex-wrap gap-4 md:gap-6 text-[#718096] text-sm justify-center md:justify-end">
              <Link to="/terms" className="hover:text-[#00E5C0] transition-colors">
                Terms of Service
              </Link>
              <Link to="/privacy" className="hover:text-[#00E5C0] transition-colors">
                Privacy Policy
              </Link>
              <Link to="/cookie-policy" className="hover:text-[#00E5C0] transition-colors">
                Cookie Policy
              </Link>
              <Link to="/ai-disclaimer" className="hover:text-[#00E5C0] transition-colors">
                AI Use & Disclaimer
              </Link>
              <Link to="/cookie-settings" className="hover:text-[#00E5C0] transition-colors">
                Cookie Settings
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
